/**
 * Returns discount amount for the product taking into account single or multi-account product types.
 *
 * @param product
 * @param currency
 * @return {number}
 *
 * product_id === 7 doBoard
 */
export default (product, currency) => {
    if (!product) return 0;

    const curr = currency?.currency;

    // для product_id = 7
    if (product.product_id === 7 && product?.account_discount_local) {
        return product?.account_discount_local[curr] ?? product?.account_discount_default ?? 0;
    }

    // если есть скидка в локальной валюте
    if (curr && Object.prototype.hasOwnProperty.call(product.discount_local ?? {}, curr)) {
        return product.discount_local[curr] ?? product?.discount_amount;
    }

    // дефолтная скидка
    return product?.discount_amount || 0;
};

